import React, { useState, useEffect, useRef } from "react";
import { Button, Box, Image, HStack, Pressable } from "native-base";
import {
  AddPhotoIcon,
  TeamBackground,
  BrushIcon,
} from "../../assets/icons/icon-assets";
import { useDropzone } from "react-dropzone";
import { useParams } from "react-router-dom";
import { useSelector, RootStateOrAny } from "react-redux";
import * as AV from "../../AVCore/AVCore";
import { GithubPicker } from "react-color";

const AVCoverPic = ({
  Entity,
  setEntity,
  handleUpload,
  profile,
  setProfile,
  isCreate,
  isShowEdit,
  type,
  isAdminView,
  editAccess,
  isShowPicker,
  setIsShowpicker,
  imageLoader,
  setImageLoader,
  openPreview,
}) => {
  const params = useParams();
  const currentUser = useSelector(
    (state: RootStateOrAny) => state.user.user[0],
  );
  const [backgroundImage, setBackgroudImage] = useState<any>(
    isCreate
      ? null
      : AV.Media.getURL(Entity?.profile?.background)
        ? AV.Media.getURL(Entity?.profile?.background)
        : null,
  );
  const [IsLoader, setIsLoader] = useState(false);
  const [isEventCanceled, setIsEventCanceled] = useState(false);
  const [bannerColor, setBannerColor] = useState(
    Entity?.profile?.color ? Entity?.profile?.color : "AVColor.secondary",
  );

  const seriesId =
    params?.seriesId !== "undefined" && params?.seriesId !== undefined
      ? params?.seriesId
      : null;

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      setBackgroudImage(
        isCreate
          ? null
          : AV.Media.getURL(Entity?.profile?.background)
            ? AV.Media.getURL(Entity?.profile?.background)
            : null,
      );
      setProfile({
        background: null,
        pic: null,
        thumb: null,
        gallery: null,
        previousPic: null,
        text: null,
        color: null,
      });
      if (Entity && !profile) setProfile(Entity?.profile);
    }
    return () => {
      isMounted = false; // Set the flag to false when the component is unmounted
      // Cancel subscriptions or perform any cleanup tasks here
    };
  }, [isCreate, Entity]);

  const { getRootProps: getBackgroundFile, getInputProps: getBgImageProps } =
    useDropzone({
      //accept: 'image/*',
      accept: "image/jpeg,image/jfif,image/png,image/gif",
      onDrop: (acceptedFiles) => {
        setIsLoader(true);
        setImageLoader(true);
        if (
          acceptedFiles.length > 0 &&
          acceptedFiles[0].type.startsWith("image") &&
          acceptedFiles[0].type !== "image/webp"
        ) {
          setBackgroudImage(URL.createObjectURL(acceptedFiles[0]));
        } else {
          // Handle non-image files
          // Implement your validation or error handling logic here
          console.log("Unsupported file type. Please drop an image file.");
          setIsLoader(false);
          return;
        }
        getMedia(acceptedFiles)
          .then((res) => {
            setProfile((profile: any) => {
              return { ...profile, background: res };
            });
            if (!profile) {
              profile = {
                background: null,
                pic: Entity?.profile?.pic ? Entity?.profile?.pic : null,
                thumb: null,
                gallery: null,
                previousPic: null,
                text: null,
                color: Entity?.profile?.color ? Entity?.profile?.color : null,
              };
            }
            profile.pic = Entity?.profile?.pic?.id
              ? Entity?.profile?.pic
              : profile?.pic?.id
                ? profile?.pic
                : null;
            profile.color = Entity?.profile?.color
              ? Entity?.profile?.color
              : null;
            profile.text = Entity?.profile?.text
              ? Entity?.profile?.text
              : profile?.text
                ? profile?.text
                : null;
            profile.background = [];
            res = { ...res, parent: AV.AVEntity.getFk(Entity) } as AV.IMedia;
            profile.background = res;
            setProfile(profile);
          })

          .then((x) => {
            if (!isCreate) {
              Entity.profile = profile;
              handleUpload(Entity);
              setImageLoader(false);
            }
          });
      },
    });

  const getMedia = async (file: any) => {
    const updatedFiles = file.map((file) => {
      const fileName = file.name;
      if (fileName.toLowerCase().endsWith(".jfif")) {
        const updatedFileName = fileName.replace(/\.\w+$/, ".jpg");
        const updatedFile = new File([file], updatedFileName, {
          type: "image/jpeg",
        });
        return updatedFile;
      } else {
        return file;
      }
    });
    file = updatedFiles;
    let iMedia = await AV.Media.saveFiles(
      AV.Media.getFormData(file),
      Entity?.region ? Entity?.region : currentUser?.region,
    );

    if (!iMedia || iMedia.length === 0) return;

    //// Get uploaded link
    //const srclink = AV.Media.getURL(iMedia[0]);
    //if (!srclink) return;

    //// Set metadata before saving
    //iMedia[0].parent = AV.AVBase.getFk(Entity ?? currentUser);
    ////iMedia[0].linkURL = srclink;

    //// Save uploaded media
    //await AV.Media.saveMedia(iMedia);

    setIsLoader(false);
    return iMedia[0];
  };

  const handleBanner = async (color) => {
    const oldEntity = JSON.parse(JSON.stringify(Entity));
    setBannerColor(color.hex);
    setProfile((profile) => {
      return { ...profile, color: color.hex };
    });
    let img: any = {
      background: null,
      pic: null,
      thumb: null,
      gallery: null,
      previousPic: null,
      text: null,
      color: null,
    };
    if (Entity.profile) img = Entity.profile;
    if (!img.color) img.color = [];
    img.color = color.hex;
    Entity.profile = img;
    setProfile(img);
    setIsShowpicker(false);
    try {
      await handleUpload(Entity);
    } catch (error) {
      setEntity(oldEntity);
      setProfile(oldEntity?.profile);
      setBannerColor(
        oldEntity?.profile?.color
          ? oldEntity?.profile?.color
          : "AVColor.secondary",
      );
    }
  };

  const checkEventCanceled = () => {
    if (Entity?.type !== "Event") {
      return false;
    }

    // Check main event
    if (Entity?.status === "Canceled") {
      return true;
    }

    // Check series event
    if (
      Entity?.seriesEvents !== undefined &&
      Entity?.seriesEvents?.length > 0
    ) {
      const currentEvent = Array.isArray(Entity?.seriesEvents)
        ? Entity.seriesEvents.find((x) => x.id === seriesId)
        : null;

      const currentEventObj = currentEvent || Entity;

      return currentEventObj?.status === "Canceled";
    }

    return false;
  };

  useEffect(() => {
    setProfile(Entity?.profile);

    const isCanceled = checkEventCanceled();
    setIsEventCanceled(isCanceled);
  }, [Entity?.mascot, isShowEdit, Entity?.profile, Entity?.status]);

  const menuRef = useRef(null);

  useOutsideAlerter(menuRef);
  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setIsShowpicker(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  return (
    <>
      {type !== "Feedback" &&
        (Entity?.type === "Event" || Entity?.type === "Game"
          ? Entity?.profile?.background?.id
          : true) && (
          <Box
            width={"100%"}
            bgColor={type === "Feedback" ? "white" : "gray.300"}
            borderTopLeftRadius={10}
            borderTopRightRadius={10}
            height={type === "Feedback" ? "140px" : "230px"}
          >
            {(type === "Feedback" ||
              Entity?.type == "Event" ||
              Entity?.type === "Game") && (
              <Box
                backgroundColor={bannerColor}
                height={"42px"}
                display={"flex"}
                alignItems={"flex-end"}
                pt={0.5}
                borderTopLeftRadius={"10px"}
                borderTopRightRadius={"10px"}
              >
                <HStack ref={menuRef}>
                  <Box>
                    {isShowPicker && (
                      <Box
                        marginTop={"42px"}
                        position="absolute"
                        right="0"
                        zIndex={999}
                      >
                        <GithubPicker
                          color={bannerColor}
                          onChangeComplete={handleBanner}
                          width={"400px"}
                        />
                      </Box>
                    )}

                    {editAccess && isAdminView && (
                      <Button
                        bgColor={"AVColor.white"}
                        position={"absolute"}
                        top={"5px"}
                        right={"24px"}
                        height={"32px"}
                        width={"32px"}
                        rounded={"full"}
                        _hover={{ backgroundColor: "AVColor.hovercolor" }}
                        shadow={4}
                        _spinner={{ color: "AVColor.black" }}
                        zIndex={99}
                        onPress={() => {
                          setIsShowpicker(!isShowPicker);
                        }}
                      >
                        <BrushIcon height={"22"} width={"22"} color={"black"} />
                      </Button>
                    )}
                  </Box>

                  {(editAccess &&
                    isAdminView &&
                    !Entity?.profile?.background) ||
                    (isShowEdit && (
                      <Button
                        bgColor={"AVColor.white"}
                        position={"absolute"}
                        top={"5px"}
                        right={"69px"}
                        height={"32px"}
                        width={"32px"}
                        rounded={"full"}
                        _hover={{ backgroundColor: "AVColor.hovercolor" }}
                        shadow={4}
                        _spinner={{ color: "AVColor.black" }}
                        zIndex={99}
                        //isDisabled={imageLoader}
                        isLoading={IsLoader}
                      >
                        <Box {...getBackgroundFile({ className: "dropzone" })}>
                          <input {...getBgImageProps()} />
                          <AddPhotoIcon size={"22px"} color={"black"} />
                        </Box>
                      </Button>
                    ))}
                </HStack>
              </Box>
            )}

            {((type !== "Feedback" &&
              Entity?.type !== "Event" &&
              Entity?.type !== "Game" &&
              !Entity?.profile?.background &&
              isAdminView &&
              Entity?.status !== "Deleted") ||
              isCreate ||
              (isShowEdit &&
                Entity?.type !== "Event" &&
                Entity?.type !== "Game")) && (
              <Button
                bgColor={"AVColor.white"}
                position={"absolute"}
                top={"20px"}
                right={"27px"}
                height={"40px"}
                width={"40px"}
                rounded={"full"}
                _hover={{ backgroundColor: "AVColor.hovercolor" }}
                shadow={4}
                _spinner={{ color: "AVColor.black" }}
                zIndex={99}
                //isDisabled={ imageLoader }
                isLoading={IsLoader}
              >
                <Box {...getBackgroundFile({ className: "dropzone" })}>
                  <input {...getBgImageProps()} />
                  <AddPhotoIcon size={"28px"} color={"black"} />
                </Box>
              </Button>
            )}

            {Entity?.profile?.background || profile?.background ? (
              <Pressable
                style={{
                  height:
                    Entity?.type === "Event" ||
                    Entity?.type === "Game" ||
                    Entity?.type === "LeagueGameBase"
                      ? "94%"
                      : "100%",
                  width: "100%",
                  borderTopLeftRadius:
                    Entity?.type === "Event" ||
                    Entity?.type === "Game" ||
                    Entity?.type === "LeagueGameBase"
                      ? 0
                      : 10,
                  borderTopRightRadius:
                    Entity?.type === "Event" ||
                    Entity?.type === "Game" ||
                    Entity?.type === "LeagueGameBase"
                      ? 0
                      : 10,
                  zIndex: -3,
                }}
                onPress={() =>
                  openPreview(
                    Entity?.profile?.background
                      ? Entity?.profile?.background
                      : profile?.background,
                    Entity?.profile?.background
                      ? Entity?.profile?.background
                      : profile?.background,
                  )
                }
              >
                <Image
                  style={{
                    height:
                      Entity?.type === "Event" ||
                      Entity?.type === "Game" ||
                      Entity?.type === "LeagueGameBase"
                        ? "94%"
                        : "100%",
                    width: "100%",
                    borderTopLeftRadius:
                      Entity?.type === "Event" ||
                      Entity?.type === "Game" ||
                      Entity?.type === "LeagueGameBase"
                        ? 0
                        : 10,
                    borderTopRightRadius:
                      Entity?.type === "Event" ||
                      Entity?.type === "Game" ||
                      Entity?.type === "LeagueGameBase"
                        ? 0
                        : 10,
                    zIndex: -3,
                  }}
                  source={{
                    uri: backgroundImage,
                  }}
                />
              </Pressable>
            ) : (
              <TeamBackground />
            )}
          </Box>
        )}

      {type === "Feedback" && (
        <Box
          width={"100%"}
          bgColor={type === "Feedback" ? "white" : "gray.300"}
          borderTopLeftRadius={10}
          borderTopRightRadius={10}
          height={type === "Feedback" ? "140px" : "230px"}
        >
          <Box
            backgroundColor={"#32AE78"}
            height={"42px"}
            display={"flex"}
            alignItems={"flex-end"}
            pt={0.5}
            borderTopLeftRadius={"10px"}
            borderTopRightRadius={"10px"}
          ></Box>
        </Box>
      )}

      {(Entity?.type === "Event" || Entity?.type === "Game") &&
        !Entity?.profile?.background?.id && (
          <Box
            backgroundColor={bannerColor}
            height={"42px"}
            display={"flex"}
            alignItems={"flex-end"}
            pt={0.5}
            borderTopLeftRadius={"10px"}
            borderTopRightRadius={"10px"}
          >
            <HStack>
              <Box>
                <HStack ref={menuRef}>
                  {isShowPicker && (
                    <Box
                      marginTop={"42px"}
                      position="absolute"
                      right="0"
                      zIndex={999}
                    >
                      <GithubPicker
                        color={bannerColor}
                        onChangeComplete={handleBanner}
                        width={"400px"}
                      />
                    </Box>
                  )}

                  {editAccess && isAdminView && !isEventCanceled && (
                    <Button
                      //ref={menuRef}
                      bgColor={"AVColor.white"}
                      position={"absolute"}
                      top={"5px"}
                      right={"24px"}
                      height={"32px"}
                      width={"32px"}
                      rounded={"full"}
                      _hover={{ backgroundColor: "AVColor.hovercolor" }}
                      shadow={4}
                      _spinner={{ color: "AVColor.black" }}
                      zIndex={99}
                      onPress={() => {
                        setIsShowpicker(!isShowPicker);
                      }}
                    >
                      <BrushIcon height={"22"} width={"22"} color={"black"} />
                    </Button>
                  )}
                </HStack>
              </Box>

              {editAccess && isAdminView && !isEventCanceled && (
                <Button
                  bgColor={"AVColor.white"}
                  position={"absolute"}
                  top={"5px"}
                  right={"69px"}
                  height={"32px"}
                  width={"32px"}
                  rounded={"full"}
                  _hover={{ backgroundColor: "AVColor.hovercolor" }}
                  shadow={4}
                  _spinner={{ color: "AVColor.black" }}
                  zIndex={99}
                  //isDisabled={imageLoader}
                  isLoading={IsLoader}
                >
                  <Box {...getBackgroundFile({ className: "dropzone" })}>
                    <input {...getBgImageProps()} />
                    <AddPhotoIcon size={"22px"} color={"black"} />
                  </Box>
                </Button>
              )}
            </HStack>
          </Box>
        )}
    </>
  );
};

export default React.memo(AVCoverPic);
